/* eslint-disable consistent-return */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BluebirdPromise from 'bluebird';
import { withRouter, Redirect, Route } from 'react-router-dom';
import { includes, get } from 'lodash';

import PageContent from '../../../shared/components/PageContent';
import CollectionSummaryForm from '../forms/Admin/CollectionForm/CollectionSummaryForm';
import CollectionEmbed from '../forms/Admin/CollectionForm/CollectionEmbed';

import PageHeader from '../../../shared/components/PageHeader';
import Page from '../../../shared/components/Page';
import { getCollection, getManyBadges } from '../../../shared/actions';
import MenuTabs from '../../../shared/components/MenuTabs';
import { makeGetObjectsFromStateById } from '../../../shared/selectors';
import { RuntimeContext } from '../../../../common/RuntimeContext';

class ViewCollectionContainer extends Component {
    static propTypes = {
        getCollection: PropTypes.func.isRequired,
        getManyBadges: PropTypes.func,
        match: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        loggedInUser: PropTypes.object.isRequired,
        currentCollection: PropTypes.object,
        isAccountOwner: PropTypes.bool,
        allBadges: PropTypes.arrayOf(PropTypes.object),
        location: PropTypes.object
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            mediaMetadata: [],
            menuTabs: this._buildMenuTabsArray(),
            isCollectionUpdateModalOpen: false
        };
    }

    componentDidMount() {
        const { match, getCollection, getManyBadges, location, loggedInUser } = this.props;
        this.setState({
            isLoading: true
        });
        const promises = [];

        promises.push(getManyBadges({ pathsContext: this.context.pathsWeb }));
        if (match.params.id) {
            promises.push(
                getCollection({
                    collectionId: match.params.id,
                    getFullProjection: true,
                    pathsContext: this.context.pathsWeb
                })
            );
        }

        return BluebirdPromise.all(promises).then(() => {
            const copiedCollection = get(location, 'state.copiedCollection', null);
            const newState = { isLoading: false };
            if (copiedCollection) {
                newState.copiedCollection = copiedCollection;
            }
            this.setState(newState);
        });
    }

    handleCancel = () => {
        this.props.history.push('/viewcollections');
    };

    _buildMenuTabsArray = () => {
        const {
            match: { path, params }
        } = this.props;
        const isNew = includes(path, 'new');
        return [
            {
                name: 'Summary',
                icon: 'fa-cog',
                tabId: 'summary',
                title: 'Summary',
                path: `/viewcollection/${params.id}/summary`
            },
            {
                name: 'Embed',
                icon: 'fa-share',
                tabId: 'embed',
                title: 'Embed',
                path: `/viewcollection/${params.id}/embed`,
                isHidden: isNew
            }
        ];
    };

    render() {
        const {
            currentCollection = {},
            match: {
                path,
                params: { section = '' }
            },
            match,
            history,
            isAccountOwner,
            loggedInUser,
            allBadges,
            location
        } = this.props;
        const { menuTabs, isLoading } = this.state;
        const isNew = includes(path, 'new');
        const components = {
            summary: { component: CollectionSummaryForm, title: `${currentCollection.name}: Summary` },
            embed: { component: CollectionEmbed, title: `${currentCollection.name}: Embed` }
        };

        const activeMenuTabTitle = get(components[section], 'title', '');
        const title = isNew ? 'Create New Path' : activeMenuTabTitle;

        const routes = menuTabs.map((tab) => {
            if (!tab.isHidden) {
                return (
                    <Route
                        key={tab.path}
                        path={tab.path}
                        exact={true}
                        render={() => {
                            const ActiveMenuTabComponent = components[tab.tabId].component;
                            return (
                                <ActiveMenuTabComponent
                                    isLoading={isLoading}
                                    history={history}
                                    currentCollection={currentCollection}
                                    onCancel={this.handleCancel}
                                    isAccountOwner={isAccountOwner}
                                    loggedInUser={loggedInUser}
                                    allBadges={allBadges}
                                    match={match}
                                    companyAdminDisplay={true}
                                />
                            );
                        }}
                    />
                );
            }
            return null;
        });
        const renderedSideNavItems = <MenuTabs menuItems={menuTabs} initialTab={section} />;

        if (!section) {
            return (
                <Redirect
                    to={{
                        pathname: `${match.url}/summary`,
                        state: location.state // forward location state
                    }}
                />
            );
        }

        return (
            <Page className={'add-or-edit-collection-v2'}>
                <div className={'col-md-2 verticalSubMenuList'}>{renderedSideNavItems}</div>
                <div className={'col-md-10'}>
                    <PageContent className={'col-12 ms-auto container'}>
                        <PageHeader
                            title={title}
                            bottomBorder={true}
                            hideBackButton={true}
                            className={'collection-form-header'}
                        />
                        {routes}
                    </PageContent>
                </div>
            </Page>
        );
    }
}

export const mapStateToProps = (state, ownProps) => {
    const {
        auth: { isAuthenticated, loggedInUser, isContentAuthor, isAccountOwner },
        collections: { byId }
    } = state;

    const collectionId = ownProps.match.params.id;
    let currentCollection;
    if (collectionId) {
        currentCollection = byId[collectionId];
    } else {
        currentCollection = {};
    }

    const getBadgesFromStateById = makeGetObjectsFromStateById('badges');
    const allBadges = getBadgesFromStateById(state);

    return {
        allBadges,
        isAuthenticated,
        isContentAuthor,
        isAccountOwner,
        currentCollection,
        loggedInUser
    };
};

const mapDispatchToProps = (dispatch) => ({
    getCollection: (params) => dispatch(getCollection(params)),
    getManyBadges: (params) => dispatch(getManyBadges(params))
});

export const ViewCollectionContainerComponent = ViewCollectionContainer;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewCollectionContainer));
